import { Routes } from '@angular/router';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { DefaultLayoutComponent, LoginLayoutComponent } from './containers';

export const routes: Routes = [
  // Layout para usuarios autenticados
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./components/home/home.routes').then(m => m.homeRoutes)
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./components/admin/admin.routes').then(m => m.adminRoutes)
      },
      {
        path: 'whatsapp',
        loadChildren: () =>
          import('./components/whatsapp/whatsapp.routes').then(m => m.whatsappRoutes)
      }
    ]
  },
  // Layout para login
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      {
        path: 'login',
        loadChildren: () =>
          import('./components/login/login.routes').then(m => m.loginRoutes)
      }
    ]
  },
  // Fallback
  {
    path: '**',
    component: NotFoundComponent
  }
];
